const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Napravite izbor",
  seeAll: "Pogledaj sve",
  clear: "Očisti",
  back: "Nazad",
  save: "Sačuvaj",
  close: "Zatvori",
  of: "Od",
  to: "Do",
  copyrights: "© {date} Bridgestone Solutions. Sva prava zadržana.",
  pageNotFound: "Stranica nije pronađena",
  accessDenied: "Pristup odbijen",
  search: "Pretraži",
  year: "Godina",
  buttons: {
    loading: "Učitavanje...",
    export: "Izvezi",
    delete: "Obriši",
    save: "Sačuvaj",
    cancel: "Otkaži",
    next: "Dalje",
    back: "Nazad",
    skip: "Preskoči",
    send: "Pošalji",
    clear: "Očisti",
    close: "Zatvori",
    readNow: "Pročitaj sada",
    pointsList: "Lista bodova",
    more: "Više",
    reportError: "Prijavi grešku",
    accept: "Prihvati",
    download: "Preuzmi",
    downloadAll: "Preuzmi sve",
    selectAll: "Odaberi sve",
    deselectAll: "Poništi odabir",
    downloadSelection: "Preuzmi odabrano",
    dealerInfoDownload: "PREUZMI",
    toTheBasket: "U korpu",
    toOrderDelivery: "Nastavi na adresu za dostavu",
    discover: "Otkrij",
    newAddress: "Kreiraj novu adresu za dostavu",
    selectAddressBtn: "Izaberi adresu za dostavu",
    toOrderSummary: "Na pregled narudžbe",
    placeOrder: "Obavezujuća narudžba",
    toDashboard: "Na početnu stranicu",
    newOrder: "Nova narudžba",
    userOrders: "Na vaše narudžbe",
    toSearch: "Pretraži",
    select: "Izaberi",
    moreCustomerNumbers: "+ DODAJ VIŠE BROJEVA KUPACA",
    loadMore: "Učitaj više",
    toStaffDashboard: "Na kontrolnu tablu",
    toQuiz: "Na kviz",
    vouchers: "Vaučeri",
    exchangeVoucher: "Unovči kod vaučera",
    confirm: "Potvrdi",
    sharePoints: "Podijeli bodove",
    create: "Kreiraj",
    update: "Ažuriraj",
    toBDrive: "U B-Drive",
    preview: "Pregled",
    clickHere: "Prikaži detalje",
    setFilters: "Molimo postavite <b>najviše jedan filter po koloni</b>",
    all: "Sve",
  },
  tooltips: {
    info: "Trebate pomoć? 01 92 64 88 50 0",
  },
  confirmation: {
    header: "Potvrda potrebna",
    message: "Da li želite obrisati ovaj unos?",
  },
  nav: {
    consents: "Saglasnosti",
    dashboard: "Kontrolna tabla",
    accountDashboard: "Kontrolna tabla",
    account: "Profil",
    mailbox: "Primljena pošta",
    singleMailbox: "Poruke",
    stammdaten: "Osnovni podaci",
    news_feeds: "Novosti",
    pointsOverview: "Pregled bodova",
    rewardsOverview: "Pregled bodova",
    about: "O BS Plus",
    service_number: "Kontakt servis",
    shop: "Shop nagrada",
    salesPromotions: "Prodajne promocije",
    promotions: "Moj nalog",
    shopCategory: "Shop nagrada",
    productDetails: "Detalji proizvoda",
    userOrders: "Korisničke narudžbe",
    shoppingCart: "Korpa",
    orderDelivery: "Adresa za dostavu",
    orderSummary: "Pregled narudžbe",
    orderComplete: "Narudžba završena",
    text_page: "Statička stranica",
    staff: "Kontrolna tabla servisa",
    onlineTrainings: "Online treninge",
    trainings: "Treninge",
    training: "Trening",
    trainingForm: "Forma za trening",
    staffVouchers: "Vaučeri",
    wholesalerVouchers: "Vaučeri",
    brochure_prices: "Cjenovnici i brošure",
    investment: "Podrska investicijama",
    media: "Mediji",
    medias: "Mediji",
    wholesaler: "Kontrolna tabla veletrgovca",
    contact_service: "Kontakt informacije i servis",
    productInfo: "INFORMACIJE O PROIZVODU",
    bDrive: "Slike proizvoda",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Uvjeti sudjelovanja",
    first_stop: "Bridgestone garancija na gume",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Kontrolna tabla",
    accountDashboard: "Kontrolna tabla",
    account: "Profil",
    mailbox: "Primljena pošta",
    singleMailbox: "Poruke",
    stammdaten: "Osnovni podaci",
    news_feeds: "Novosti",
    pointsOverview: "Pregled bodova",
    rewardsOverview: "Pregled bodova",
    about: "O BS Plus",
    service_number: "Kontakt servis",
    shop: "Shop nagrada",
    salesPromotions: "Prodajne promocije",
    promotions: "Moj nalog",
    shopCategory: "Shop nagrada",
    productDetails: "Detalji proizvoda",
    userOrders: "Korisničke narudžbe",
    shoppingCart: "Korpa",
    orderDelivery: "Adresa za dostavu",
    orderSummary: "Pregled narudžbe",
    orderComplete: "Narudžba završena",
    staff: "Kontrolna tabla servisa",
    onlineTrainings: "Online treninge",
    trainings: "Treninge",
    training: "Trening",
    trainingForm: "Forma za trening",
    staffVouchers: "Vaučeri",
    wholesalerVouchers: "Vaučeri",
    brochure_prices: "Cjenovnici i brošure",
    investment: "Podrska investicijama",
    media: "Mediji",
    medias: "Mediji",
    wholesaler: "Kontrolna tabla veletrgovca",
    contact_service: "Kontakt informacije i servis",
    productInfo: "INFORMACIJE O PROIZVODU",
    bDrive: "Slike proizvoda",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Uvjeti sudjelovanja",
    first_stop: "Bridgestone garancija na gume",
    payouts: "Payouts",
},
  menu: {
    account: "Profil",
    plus: 'O Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Prodajna podrška",
    mailbox: "Primljena pošta",
    about: "O BS Plus",
    trainingAndCourses: "Treninge i kursevi",
    externalTraining: "Vanjski treninge",
    productInfo: "Informacije o proizvodu",
    productBrochures: "Brošure proizvoda",
    priceLists: "Cjenovnici",
    price: "Cijena",
    complaintForm: "Forma za žalbu",
    sales_support: "Prodajna podrška",
    contact_service: "Kontakt informacije i servis",
    logOut: "Odjavi se",
    news: "Novosti",
    news_feeds: "Novosti",
    service_number: "Kontakt servis",
    salesPromotions: "Prodajne promocije",
    shop: "Trgovina",
    onlineTrainings: "Online treninge",
    trainings: "Treninge",
    brochure_prices: "Cjenovnici i brošure",
    media: "Mediji",
    medias: "Mediji",
    stammdaten: "Osnovni podaci",
    preislisten: "Cjenovnici",
  },
  validation: {
    requiredField: "Polje obavezno",
  },
  sortBy: {
    default: "Sortiraj po",
    desc: "Sortiraj po: Najnovije",
    asc: "Sortiraj po: Najstarije",
    name: "Ime",
    date: "Datum",
    choiceBy: "Sortiraj",
  },
  month: {
    1: "januar",
    2: "februar",
    3: "mart",
    4: "april",
    5: "maj",
    6: "juni",
    7: "juli",
    8: "august",
    9: "septembar",
    10: "oktobar",
    11: "novembar",
    12: "decembar"
  },
};


export default {
  messages,
};
